export default __webpack_public_path__ + "static/media/guess-friends-2.4c577501.jpg";